import React, { ReactNode } from "react";
import Tag from "../../../../../generic/tag";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { INfo } from "../../../../../types/components/orderBook/obTypes";
import bStrg from "../../../../../service/storageHelper";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import { ChipStatusComb, ChipColorKeyComb } from "../../../obConstants";

export interface IObNfoMobProps {
	data: Array<INfo>;
	isHistory: boolean;
	noDataNode: ReactNode;
}

const ObNfoMob: React.FC<IObNfoMobProps> = (props) => {
	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [props.data],
		todayDate = bStrg("todayDate") || new Date();
	let tableData = initialData;
	let ncdData: Array<{ [x: string]: Array<INfo> }> | null = null,
		todaysNcds: Array<Array<{}>> | null = null;

	React.useEffect(() => {}, [props.data, props.isHistory]);

	if (props.data) {
		//group data based on biddingEndDate
		let results = tableData.map((group: Array<any>) =>
			group.reduce(
				(arr: any, d: INfo) => {
					if (new Date(d.txnDate).setHours(0, 0, 0).valueOf() === new Date(todayDate).setHours(0, 0, 0).valueOf()) {
						arr[0] = [...arr[0], d];
					} else {
						arr[1] = [...arr[1], d];
					}
					return arr;
				},
				[[], []]
			)
		);
		if (!props.isHistory) {
			todaysNcds = results[0][0].length > 0 ? [results[0][0]] : null;
		} else {
			ncdData = results[0][1].length > 0 ? [HObGroupBy(results[0][1], "txnDate", "T")] : null;
		}
	}

	function ncdRw(item: INfo, groupIndex: number, index: number) {
		return (
			<div className="nfo_mob new_offers_mob_con" key={index}>
				<div className="tag">
					<Tag value="B" shape="mini_circle" color="green" height="30px" width="30px" />
				</div>
				<div className="new_offers_data">
					<div className="date"> {item.txnDate.split(" ")[1].toLowerCase().trim()}</div>
					<div className="comp_con">
						<div className="sym">{item.schemeName}</div>

						<div className="sts">
							<Tag value={ChipStatusComb[item.status.toLowerCase()]} color={ChipColorKeyComb[item.status.toLowerCase()]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="amt">₹{item.amount}</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<>
			<React.Fragment>
				{
					props.isHistory
						? ncdData !== null &&
						  ncdData.map((group, groupIndex) =>
								Object.keys(group).map((date, GIindex) => {
									return (
										<React.Fragment key={GIindex}>
											{/* if history componenet need to show*/}

											<ul className="eq_hist_date hist_date" key={"dtGp" + GIindex}>
												<li>{date.split("T")[0]}</li>
											</ul>
											<ul key={"dtUlDet" + GIindex}>
												{group[date].map((row: any, index: number) => ncdRw(row, GIindex, index))}
											</ul>
										</React.Fragment>
									);
								})
						  )
						: todaysNcds !== null &&
						  todaysNcds.map((group: any, groupIndex: number) =>
								// Object.keys(group).map((grp: any, index) =>
								{
									return (
										<React.Fragment key={groupIndex}>
											{group.length > 0 && (
												<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
													{group.map((row: any, index: number) => (
														<React.Fragment key={index}>{ncdRw(row, groupIndex, index)}</React.Fragment>
													))}
												</ul>
											)}
										</React.Fragment>
									);
								}
						  )
					// )
				}
			</React.Fragment>

			{((ncdData === null && props.isHistory) || (todaysNcds === null && !props.isHistory)) && props.noDataNode}
		</>
	);
};

export default ObNfoMob;
